import { useRef } from 'react';

export const useFocusTextField = () => {
  const htmlElRef = useRef(null);
  const setFocus = () => {
    if (!htmlElRef || !htmlElRef.current) {
      return;
    }

    const input = htmlElRef.current.querySelector('input');

    if (input) {
      input.focus();
    }
  };
  return [htmlElRef, setFocus];
};
